var _path, _path2, _line, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPassportCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.573 0L19.3315 5.43505C19.814 5.70378 19.9873 6.31277 19.7186 6.79527L11.1186 22.2364C10.8499 22.7189 10.2409 22.8922 9.75839 22.6234L-0.000133675 17.1884L9.573 0Z",
    fill: "#314CA3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5378 11.7268C10.7508 11.8455 10.9852 11.921 11.2275 11.9492C11.4697 11.9773 11.7152 11.9574 11.9497 11.8907C12.1843 11.8239 12.4035 11.7116 12.5946 11.5602C12.7858 11.4088 12.9453 11.2212 13.064 11.0081C13.1827 10.7951 13.2582 10.5607 13.2864 10.3185C13.3145 10.0762 13.2946 9.83076 13.2279 9.59618C13.1611 9.3616 13.0489 9.14246 12.8974 8.95127C12.746 8.76008 12.5584 8.60059 12.3453 8.48191M10.5378 11.7268C10.3247 11.6081 10.1371 11.4486 9.98569 11.2574C9.83427 11.0662 9.72198 10.8471 9.65525 10.6125C9.58852 10.3779 9.56864 10.1325 9.59676 9.89025C9.62487 9.64798 9.70043 9.41363 9.81912 9.20057C9.9378 8.98751 10.0973 8.79991 10.2885 8.64848C10.4797 8.49706 10.6988 8.38477 10.9334 8.31804C11.168 8.25131 11.4134 8.23143 11.6557 8.25955C11.8979 8.28766 12.1323 8.36322 12.3453 8.48191M10.5378 11.7268C11.0355 12.0041 11.7667 11.1918 12.152 10.5001C12.5373 9.80841 12.8431 8.75917 12.3453 8.48191M10.5378 11.7268C10.0401 11.4495 10.3458 10.4003 10.7311 9.70859C11.1164 9.01689 11.8476 8.20465 12.3453 8.48191M10.2105 8.70996L13.2751 10.4171M9.60799 9.79159L12.6726 11.4987",
    stroke: "#FCD626",
    strokeWidth: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 6.91349,
    y1: 11.6335,
    x2: 12.1457,
    y2: 14.5481,
    stroke: "#4365D0"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.57275,
    y: 0.00390625,
    width: 0.582949,
    height: 19.6713,
    transform: "rotate(29.12 9.57275 0.00390625)",
    fill: "#223E97"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassportCard);
export default __webpack_public_path__ + "static/media/passport_card.b76e930412bd327f027ada0b9c8b4334.svg";
export { ForwardRef as ReactComponent };